import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./HomeInfluencerSection.css";
import { useCurrency } from "../../Context/CurrencyContext";

// Constants for image handling
const BASE_URL = "https://volumaire.backendapihub.com";
const DEFAULT_IMAGE = "/images/dailyroutine2.webp";

function HomeInfluencerSection() {
  const navigate = useNavigate();
  const { formatPrice } = useCurrency();

  const staticReviews = [
    {
      id: 42,
      image: "/images/3rdsectionimage1.webp",
      title: "Orchid",
      subtitle: "Orchid Antioxidant Beauty Face Oil",
      price: 5500,
      priceValue: 5500,
      brand: "MOKOSH",
      type: "Face Oil"
    },
    {
      id: 46,
      image: "/images/3rdsectionimage2.webp",
      title: "Bakuchiol",
      subtitle: "Smoothing serum",
      price: 6800,
      priceValue: 6800,
      brand: "BKIND",
      type: "Serum"
    },
    {
      id: 47,
      image: "/images/3rdsectionimage3.webp",
      title: "Eye Anti-Aging",
      subtitle: "Check out our Corrective eye cream Green tea",
      price: 2700,
      priceValue: 2700,
      brand: "MOKOSH",
      type: "Cream"
    },
  ];

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [useFallback, setUseFallback] = useState(false);

  const normalizeImageUrl = (imageUrl) => {
    if (!imageUrl || imageUrl.trim() === "" || imageUrl === "null" || imageUrl === "undefined") {
      return null;
    }

    if (
      imageUrl.startsWith("http://") ||
      imageUrl.startsWith("https://") ||
      imageUrl.startsWith("data:")
    ) {
      return imageUrl;
    }

    if (imageUrl.startsWith("/")) {
      return `${BASE_URL}${imageUrl}`;
    }

    return `${BASE_URL}/${imageUrl}`;
  };

  const isValidImageUrl = (url) => {
    if (!url) return false;
    const strUrl = String(url).trim();
    return (
      strUrl !== "" &&
      strUrl !== "null" &&
      strUrl !== "undefined" &&
      !strUrl.includes("undefined") &&
      !strUrl.includes("null")
    );
  };

  useEffect(() => {
    const fetchBestsellers = async () => {
      try {
        setLoading(true);
        const apiUrl =
          "https://volumaire.backendapihub.com/api/complete-products/bestsellers?countryCode=US";

        const response = await fetch(apiUrl, {
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/json")) {
          throw new Error("Response is not JSON");
        }

        const data = await response.json();

        let productArray = [];
        if (Array.isArray(data)) {
          productArray = data;
        } else if (data && Array.isArray(data.products)) {
          productArray = data.products;
        } else if (data && Array.isArray(data.data)) {
          productArray = data.data;
        } else if (data && data.results && Array.isArray(data.results)) {
          productArray = data.results;
        }

        const productsWithValidImage = productArray.map((product) => {
          const rawImage = product.images?.[0] || product.image;
          const normalizedImage = isValidImageUrl(rawImage)
            ? normalizeImageUrl(rawImage)
            : DEFAULT_IMAGE;

          return {
            ...product,
            finalImage: normalizedImage,
          };
        });

        setProducts(productsWithValidImage.slice(0, 3));
        setUseFallback(false);
      } catch (err) {
        console.error("Failed to fetch bestsellers:", err);
        setUseFallback(true);
      } finally {
        setLoading(false);
      }
    };

    fetchBestsellers();
  }, []);

  const mapProductToReview = (product) => ({
    id: product.id,
    image: product.finalImage || DEFAULT_IMAGE,
    title: product.name || product.title || "Product",
    subtitle: product.short_description || product.description || "",
    price: product.price || 0,
    priceValue: product.price || 0,
    brand: product.brand?.name || product.brand || "",
    type: product.category?.name || product.type || "",
  });

  const influencerReviews = useFallback
    ? staticReviews
    : products.map(mapProductToReview);

  const handleCardClick = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleShopNowClick = (productId, e) => {
    e.stopPropagation();
    navigate(`/product/${productId}`);
  };

  if (loading && !useFallback) {
    return (
      <section className="influencer-section-three">
        <div className="loading-spinner">Loading products...</div>
      </section>
    );
  }

  if (influencerReviews.length === 0) {
    return null;
  }

  return (
    <section className="influencer-section-three">
      <div className="influencer-reviews-three">
        {influencerReviews.map((item, index) => (
          <div
            className="review-card-three"
            key={item.id || index}
            onClick={() => handleCardClick(item.id)}
          >
            <div className="image-wrapper-three">
              <img
                src={item.image}
                alt={item.title}
                loading="lazy"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = DEFAULT_IMAGE;
                }}
              />
            </div>

            <div className="overlay-content-three">
              <h1>{item.title}</h1>

              {/* ❌ PRICE REMOVED */}
              {/* <p className="price-three">{formatPrice(item.price)}</p> */}

              <button
                className="shop-now-btn-three"
                onClick={(e) => handleShopNowClick(item.id, e)}
              >
                SHOP NOW
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HomeInfluencerSection;